import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Button } from '../../../../Controls/Button';
export const TableActionButton = memo(forwardRef(function TableActionButton({ children, ...props }, ref) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsx(Button, { ...props, iconOnly: !isMobile, ghost: true, ref: ref, children: children }));
}));
